import React, { useEffect, useRef } from 'react'
import './Left.css'
import leftTitle from '../assets/left_title.png'
import leftImage from '../assets/left_image.png'
import { ADMINS } from '../constants'
import lottie from 'lottie-web';
import skull from '../assets/Skull.json'
import bat from '../assets/Bat.json'

import land from '../assets/left/land.png'
import chest from '../assets/left/chest.png'
import astro from '../assets/left/astro.png'
import bone from '../assets/left/bone.png'
import diamond from '../assets/left/diamond.png'
import emerald from '../assets/left/emerald.png'
import gem from '../assets/left/gem.png'
import citrine from '../assets/left/citrine.png'
import lightningEpic from '../assets/left/lightning_epic.png'
import lightningRare from '../assets/left/lightning_rare.png'
import lightningUncommon from '../assets/left/lightning_uncommon.png'
import purpleGem from '../assets/left/purple_gem.png'
import zoombiesCoin from '../assets/left/zoombies_coin.png'
import crystalSkull from '../assets/left/crystal_skull.png'

const Left = (props) => {

    const skullAnim = useRef(null);
    const skullContainer = useRef(null);
    const batAnim = useRef(null);
    const batContainer = useRef(null);

    const adminButtonHandler = () => {
        if(ADMINS.includes(props.account)) {
            props.onAdmin(!props.displayAdmin);
        }
    }

    useEffect( () => {
        if(skullContainer.current) {
            skullAnim.current = lottie.loadAnimation({
                container: skullContainer.current,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: JSON.parse(JSON.stringify(skull))
            })

            return () => {
                skullAnim.current?.destroy();
            }
        }
    }, [])

    useEffect( () => {
        if(batContainer.current) {
            batAnim.current = lottie.loadAnimation({
                container: batContainer.current,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: JSON.parse(JSON.stringify(bat))
            })

            return () => {
                batAnim.current?.destroy();
            }
        }
    }, [])

    return (
        <div className="left-container">
            <div className="left-title" onClick={adminButtonHandler}>
                <img src={leftTitle} className="ltimg" alt="Left title"/>
                <div className="lttext">
                    <div ref={skullContainer} className="skull-lottie"></div>
                    <div style={{whiteSpace: 'nowrap'}}>VIP MEMBERSHIP NFT</div>
                </div>
            </div>
            <div className="bat-outer-div">
                <div className="bat-inner-div">
                    <div ref={batContainer} className="bat-lottie"></div>
                </div>
            </div>
            <div className="left-image">
                <div className="left-image-container">
                    <img src={land} className="land"/>
                    <div className="chest">
                        <img src={chest} className="chest-img"/>

                        <img src={zoombiesCoin} className="t-zoombies-coin-l" />
                        <img src={zoombiesCoin} className="t-zoombies-coin-r" />
                        <img src={diamond} className="t-diamond" />
                        <img src={bone} className="t-bone" />
                        <img src={gem} className="t-gem" />
                        <img src={crystalSkull} className="t-crystal-skull" />

                        <img src={lightningEpic} className="lightening-epic"/>
                        <img src={lightningRare} className="lightening-rare"/>
                        <img src={lightningUncommon} className="lightening-uncommon"/>

                        <img src={emerald} className="b-emerald"/>
                        <img src={diamond} className="b-diamond"/>
                        <img src={gem} className="b-gem"/>
                        <img src={citrine} className="b-citrine"/>
                        <img src={purpleGem} className="b-purple-gem"/>
                    </div>
                    <img src={astro} className="astro"/>
                </div>
            </div>
        </div>
    )
}

export default Left